import { getByPath } from "../../../../dot-notation/index.js";
function createTransformApi(store) {
  const fieldTransforms = /* @__PURE__ */ new Map();
  function applyTransforms(formApi, initialChangedValues, fieldToSkip) {
    const changedValues = { ...initialChangedValues };
    for (const [targetFieldName, fieldTransform] of fieldTransforms) {
      if (fieldToSkip && targetFieldName === fieldToSkip) continue;
      const initialChangedValue = initialChangedValues[targetFieldName];
      const changedValue = changedValues[targetFieldName];
      if (fieldTransform && changedValue && initialChangedValue) {
        const transformedValue = fieldTransform(formApi, changedValue, initialChangedValue, targetFieldName);
        const prevValue = getByPath(store.values, targetFieldName);
        if (prevValue !== transformedValue) {
          changedValues[targetFieldName] = transformedValue;
        } else {
          delete changedValues[targetFieldName];
        }
      }
    }
    return changedValues;
  }
  const transformApi = {
    addFieldTransform: (fieldName, transform) => {
      if (fieldTransforms.has(fieldName)) {
        console.warn(`Overwriting the Field Transform registered for the field: ${String(fieldName)}.`);
      }
      fieldTransforms.set(fieldName, transform);
    },
    removeFieldTransform: (fieldName) => {
      return fieldTransforms.delete(fieldName);
    },
    removeAllFieldTransforms: () => {
      const transformIds = fieldTransforms.keys();
      for (const transformId of transformIds) {
        transformApi.removeFieldTransform(transformId);
      }
    }
  };
  return { fieldTransforms, applyTransforms, transformApi };
}
export {
  createTransformApi
};
//# sourceMappingURL=createTransformApi.js.map
